import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG, EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAIL } from "./actionTypes";

const initialState = {
  error: "",
  success: "",
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state };
      break;
      case PROFILE_SUCCESS:
        state = { ...state, success: action.payload };
        break;
    case EDIT_PROFILE_FAIL:
      // The below must contain a string and not an object or array. Get the exact message being sent from the reducer
      // Same as EDIT_PROFILE_SUCCESS below
      state = { ...state, error: action.payload.err };
      break;
    case EDIT_PROFILE_SUCCESS:
      state = { ...state, success: action.payload.success };
      break;
    case PROFILE_ERROR:
      state = { ...state, error: action.payload };
      break;
    case RESET_PROFILE_FLAG:
      state = { ...state, success: null };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
